<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header v-if="isSelect">
        <div>
          <div class="flex align-items marginRight10 marginBottom10">
            <span class="span marginRight10">视频分类 : </span>
            <div class="width300">
              <el-select v-model="searchData.classifyId" clearable>
                <el-option
                  v-for="item in classifyList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >视频名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>
          </div>
        </div>
      </template>

      <template slot="videoId" slot-scope="{ row }">
        <div v-if="isSelect">{{ row.id }}</div>
        <div v-else>{{ row.videoId }}</div>
      </template>
      <template slot="mainImage" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.mainImage"
          :preview-src-list="[row.mainImage]"
        >
        </el-image>
      </template>

      <template slot="menu" slot-scope="{ row }" v-if="!isSelect">
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { questionTestVideoList } from "@/api/question/test";
import { mapGetters } from "vuex";
import { videoListClassify, videoManageList } from "@/api/video/manage";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";

export default {
  name: "index",
  components: {
    FormImgUpload,
    FormVideoUpload,
  },
  props: {
    isSelect: {
      type: Boolean,
      default: false,
    },
    paperId: {
      type: String,
      default: "",
    },
    videoIds: {
      type: Array,
      default: [],
    },
    classifyList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      button: {},
      showAuthority: true,
      isDetails: false,
      typeList: [],
      entryList: [],
      searchData: {
        name: "",
        projectId: "",
        classifyId: "",
      },

      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      selectedRowKeys: [], // 选中的行
      menuAlign: "center",
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: !this.isSelect, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: !this.isSelect,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        column: [
          {
            label: "视频ID",
            prop: "videoId",
          },
          {
            label: "视频名称",
            prop: "name",
          },
          {
            label: "主图",
            prop: "mainImage",
          },
          {
            label: "视频分类",
            prop: "classifyName",
          },
        ],
      },

      dialogVisible: false,
      form: {
        image: [],
        state: 1,
        type: 1,
        jumpType: null,
        jumpId: null,
      },

      dialogPassWordVisible: false,
    };
  },

  created() {},
  mounted() {
    console.log(this.paperId, "paperId");
  },
  watch: {
    videoIds: {
      handler(newVal) {
        console.log(newVal, "newVal");
        this.selectedRowKeys = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        // path: this.$route.path,
        // searchData: this.searchData,
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchForm.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchForm.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchForm.createTime;
      this.showLoading = true;
      //   区分选择的视频 还是所有的视频
      if (this.isSelect) {
        this.option.selection = true;
        videoManageList({
          page: this.page.currentPage,
          size: this.page.pageSize,
          ...searchForm,
        }).then((res) => {
          this.showLoading = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          }
        });
      } else {
        this.option.selection = false;
        console.log(this.paperId, "paperId2222222222");
        questionTestVideoList({
          page: this.page.currentPage,
          size: this.page.pageSize,
          paperId: this.paperId,
          ...searchForm,
        }).then((res) => {
          this.showLoading = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          }
        });
      }
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 删除
    handleDelete(row) {
      this.$emit("handleDelete", row);
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectedRowKeys = list;
      this.$emit("selectionChange", list);
    },
  },
};
</script>

<style scoped>
.main-content {
  min-height: 200px;
}
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
